import React from "react";
import { isEmpty } from "lodash";
import { ImageGallery } from "@sonder/ui/source/styled/fragments/ImageGallery";
import { PanelCard } from "@sonder/ui/source/styled/fragments/PanelCard";
import { TaskData } from "core/queries/GetTask";
import { Attachments } from "tasks/components/TaskPanel/Attachments";

export const AttachmentsCard = ({ task }: { task: TaskData }) => {
  return isEmpty(task.attachments) ? null : (
    <PanelCard>
      <ImageGallery>
        <Attachments attachments={task.attachments} />
      </ImageGallery>
    </PanelCard>
  );
};
